import Vue from 'vue';
import Router from 'vue-router';
import DashboardView from './views/Dashboard.vue';
import ContractsView from './views/Contracts.vue';
import PartiesView from './views/Parties.vue';
import ClaimsView from './views/Claims.vue';
import PartyView from './views/Party.vue';
import ClaimView from './views/Claim.vue';
import AdministrationView from './views/Administration.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardView,
    },
    {
      path: '/contracts',
      name: 'contracts',
      component: ContractsView,
    },
    {
      path: '/parties',
      name: 'parties',
      component: PartiesView,
    },
    {
      path: '/parties/:id',
      name: 'party',
      component: PartyView,
    },
    {
      path: '/claims',
      name: 'claims',
      component: ClaimsView,
    },
    {
      path: '/claims/:id',
      name: 'claim',
      component: ClaimView,
    },
    {
      path: '/admin',
      name: 'administration',
      component: AdministrationView,
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue'),
    },
    {
      path: '*',
      redirect: '/dashboard',
    },
  ],
});

router.beforeEach((to, from, next) => {
  // logout
  const logoutPages = ['/logout'];
  if (logoutPages.includes(to.path)) {
    localStorage.removeItem('jwt');
  }
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const token = localStorage.getItem('jwt');

  if (authRequired && !token) {
    return next('/login');
  }

  next();
});

export default router;
